import misc from './misc';

const { getEmailQuery, buildTestEmail } = misc;

export default {
  welcomeNewUsersEmail: {
    title: 'Welcome Email',
    description: '10 minutes after signup',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      // {
      //   key: 'preferences.sendWeeklyEmployeeNewJobsEmails',
      //   label: 'Send weekly summary emails to employees',
      //   description: 'Send employees a weekly summary email with new jobs & new matches on the platform',
      //   type: 'boolean',
      // },
      {
        key: 'preferences.employeeWelcomeEmailEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_WELCOME_EMAIL_SUBJECT',
        label: 'Email Subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_WELCOME_EMAIL_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_WELCOME_EMAIL_BODY_ONE',
        label: 'Email Content',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('account/welcome-user', {
      template_subject: 'template.EMAIL_EMPLOYEE_WELCOME_EMAIL_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_WELCOME_EMAIL_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_WELCOME_EMAIL_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeWelcomeEmailEmailPlain
        canSyncContacts
      }

      template_subject: template(where: { key: "EMAIL_EMPLOYEE_WELCOME_EMAIL_SUBJECT", lang: "en", default: false }) {
        value
      }
      template_bodyOne: template(where: { key: "EMAIL_EMPLOYEE_WELCOME_EMAIL_BODY_ONE", lang: "en", default: false }) {
        value
      }
      template_bodyTwo: template(where: { key: "EMAIL_EMPLOYEE_WELCOME_EMAIL_BODY_TWO", lang: "en", default: false }) {
        value
      }
      template_bodyThree: template(where: { key: "EMAIL_EMPLOYEE_WELCOME_EMAIL_BODY_THREE", lang: "en", default: false }) {
        value
      }
      template_plainHTML: template(where: { key: "EMAIL_EMPLOYEE_WELCOME_EMAIL_PLAIN_HTML", lang: "en", default: false }) {
        value
      }`
    }),
  },
  imWelcomeNewUsersEmail: {
    title: 'Internal Mobility » Welcome email',
    description: '10 minutes after signup',
    hide: ({ isReferralsFeatureEnabled, isInternalMobilityEnabled }) => isReferralsFeatureEnabled || !isInternalMobilityEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      // {
      //   key: 'preferences.sendWeeklyEmployeeNewJobsEmails',
      //   label: 'Send weekly summary emails to employees',
      //   description: 'Send employees a weekly summary email with new jobs & new matches on the platform',
      //   type: 'boolean',
      // },
      {
        key: 'preferences.imEmployeeWelcomeEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_SUBJECT',
        label: 'Email Subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_BODY_ONE',
        label: 'Email Content',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/welcome', {
      template_subject: 'template.EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        imEmployeeWelcomeEmailPlain
        canSyncContacts
      }

      template_subject: template(where: { key: "EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_SUBJECT", lang: "en", default: false }) {
        value
      }
      template_bodyOne: template(where: { key: "EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_BODY_ONE", lang: "en", default: false }) {
        value
      }
      template_plainHTML: template(where: { key: "EMAIL_IM_EMPLOYEE_WELCOME_EMAIL_PLAIN_HTML", lang: "en", default: false }) {
        value
      }`
    }),
  },
  welcomeLinkedInReadyFirst: {
    title: 'Linkedin Archive is Ready',
    description: '15 minutes after starting to sync LinkedIn contacts',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      // {
      //   key: 'preferences.sendWeeklyEmployeeNewJobsEmails',
      //   label: 'Send weekly summary emails to employees',
      //   description: 'Send employees a weekly summary email with new jobs & new matches on the platform',
      //   type: 'boolean',
      // },
      {
        key: 'preferences.employeeReengageLinkedInReadyFirstEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_SUBJECT',
        label: 'Email Subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_BODY_ONE',
        label: 'Email Content',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/linkedin-ready-1', {
      template_subject: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        employeeReengageLinkedInReadyFirstEmailPlain
      }

      template_subject: template(where: { key: "EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_SUBJECT", lang: "en", default: false }) {
        value
      }
      template_bodyOne: template(where: { key: "EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_BODY_ONE", lang: "en", default: false }) {
        value
      }
      template_plainHTML: template(where: { key: "EMAIL_EMPLOYEE_LINKEDIN_REMINDER_FIRST_EMAIL_PLAIN_HTML", lang: "en", default: false }) {
        value
      }`
    }),
  },
  welcomeLinkedInReadySecond: {
    title: 'Linkedin Archive is Ready Reminder',
    description: '2 days after starting to sync LinkedIn contacts',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      // {
      //   key: 'preferences.sendWeeklyEmployeeNewJobsEmails',
      //   label: 'Send weekly summary emails to employees',
      //   description: 'Send employees a weekly summary email with new jobs & new matches on the platform',
      //   type: 'boolean',
      // },
      {
        key: 'preferences.employeeReengageLinkedInReadySecondEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_SUBJECT',
        label: 'Email Subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_BODY_ONE',
        label: 'Email Content',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/linkedin-ready-2', {
      template_subject: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        employeeReengageLinkedInReadySecondEmailPlain
      }

      template_subject: template(where: { key: "EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_SUBJECT", lang: "en", default: false }) {
        value
      }
      template_bodyOne: template(where: { key: "EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_BODY_ONE", lang: "en", default: false }) {
        value
      }
      template_plainHTML: template(where: { key: "EMAIL_EMPLOYEE_LINKEDIN_REMINDER_SECOND_EMAIL_PLAIN_HTML", lang: "en", default: false }) {
        value
      }`
    }),
  },
};


// WEBPACK FOOTER //
// ./src/emails/previews/welcomeEmails.js